import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store, history } from './store';
import { routes } from './routes';
import { ConnectedRouter } from 'connected-react-router';
import FeedbackForm from './components/feedback/FeedbackForm';
import './assets/styles/style';
import SmartCMAPage from './components/SmartCMAPage';
//require('dotenv').config();

// Create a container for the feedback form
const feedbackContainer = document.createElement('div');
feedbackContainer.id = 'feedback-container';
document.body.appendChild(feedbackContainer);

// Render the main app
ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      {routes}
    </ConnectedRouter>
  </Provider>,
  document.getElementById('app')
);

// Render the feedback form globally
ReactDOM.render(
  <Provider store={store}>
    <FeedbackForm />
  </Provider>,
  document.getElementById('feedback-container')
);
